<template>
  <div class="p-4">
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      label-width="80px"
    >
      <el-form-item
        label="系列预算"
        prop="budgetAmount"
      >
        <el-input
          v-model="formData.budgetAmount"
          v-to-fixed="2"
          style="width: 320px"
          type="number"
          placeholder="请输入预算金额"
          @input="emitMsg"
        >
          <el-select
            v-model="formData.budgetType"
            disabled
            @change="emitMsg"
            placeholder=""
            slot="prepend"
            style="width: 120px"
          >
            <el-option
              v-for="item in enumConstants.budgetTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <span slot="append">{{ currency }}</span>
        </el-input>
      </el-form-item>
      <!-- <div class="flex">
        <el-form-item
          label="排期"
          prop="startDate"
        >
          <el-date-picker
            v-model="formData.startDate"
            @change="emitMsg"
            type="datetime"
            placeholder="开始时间"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <span class="mx-2">~</span>
        <el-form-item
          label=""
          label-width="0"
          prop="endDate"
        >
          <el-date-picker
            v-model="formData.endDate"
            @change="emitMsg"
            type="datetime"
            placeholder="结束时间"
            :picker-options="pickerOptions1"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
      </div> -->
      <el-form-item
        label="竞价策略"
        prop="bidStrategy"
      >
        <el-radio-group
          v-model="formData.bidStrategy"
          @change="emitMsg"
        >
          <el-radio
            :label="item.value"
            v-for="item in enumConstants.searchBidStrategy"
            >{{ item.label }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item label="">
        <el-checkbox
          :label="true"
          v-model="setBidValue"
          @change="changeBidValueShow"
          >{{ enumConstants.searchBidStrategy.find((v) => v.value == formData.bidStrategy).setTypeLabel }}</el-checkbox
        >
      </el-form-item>
      <el-form-item
        label=""
        prop="bidAmount"
        v-if="setBidValue"
      >
        <el-input
          v-model="formData.bidAmount"
          v-to-fixed="2"
          placeholder="请输入"
          style="width: 240px"
          type="number"
          @input="emitMsg"
        >
          <span slot="append">
            <span v-if="formData.bidStrategy == 'MAX_CONVERSION'">{{ currency }}/转化</span>
            <span v-if="formData.bidStrategy == 'MAX_CONVERSION_VALUE'">%</span>
          </span>
        </el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'BudgetBidding',
  props: {
    enumConstants: {
      type: Object,
      default: () => ({}),
    },
    createAdAccount: {
      type: Object,
      default: () => ({}),
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        budgetType: 'DAILY',
        budgetAmount: '5',
        bidStrategy: 'MAX_CONVERSION',
        bidAmount: null,
      },
      setBidValue: false,
    };
  },
  computed: {
    currency() {
      return this.createAdAccount.currency || 'USD';
    },
    rules() {
      return {
        budgetAmount: [
          { required: true, message: '请输入预算金额', trigger: 'blur' },
          { validator: this.validateBudget, trigger: 'blur' },
        ],
        bidStrategy: [{ required: true, message: '请选择竞价策略', trigger: 'change' }],
        bidAmount: [
          { required: this.setBidValue, message: '请输入竞价金额', trigger: 'blur' },
          { validator: this.validateBidAmount, trigger: 'blur' },
        ],
      };
    },
  },
  created() {
    this.initData();
  },
  watch: {
    value: {
      handler(newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.initData();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    emitMsg() {
      // 创建新对象避免引用问题
      const data = { ...this.formData };
      this.$emit('input', data);
      this.$emit('change', data);
    },
    validateBudget(rule, value, callback) {
      const num = parseFloat(value);
      if (isNaN(num)) {
        callback(new Error('请输入有效数字'));
      } else if (num < 0.01) {
        callback(new Error('日预算最小值为0.01'));
      } else if (num > 999999999) {
        callback(new Error('日预算最大值为999999999'));
      } else {
        callback();
      }
    },
    validateBidAmount(rule, value, callback) {
      const num = parseFloat(value);
      if (isNaN(num)) {
        callback(new Error('请输入有效数字'));
      } else if (this.formData.bidStrategy === 'MAX_CONVERSION') {
        if (num < 0.01) {
          callback(new Error('最大转化策略下最小值为0.01'));
        } else if (num > 99999) {
          callback(new Error('最大转化策略下最大值为99999'));
        } else {
          callback();
        }
      } else if (this.formData.bidStrategy === 'MAX_CONVERSION_VALUE') {
        if (num < 1) {
          callback(new Error('最大转化价值策略下最小值为1'));
        } else if (num > 999999999) {
          callback(new Error('最大转化价值策略下最大值为999999999'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    // 初始化数据
    initData() {
      this.formData = {
        budgetType: this.value.budgetType || 'DAILY',
        budgetAmount: this.value.budgetAmount,
        bidStrategy: this.value.bidStrategy || 'MAX_CONVERSION',
        bidAmount: this.value.bidAmount || null,
      };
      // 强制更新setBidValue状态
      this.$set(this, 'setBidValue', !!(this.value.bidAmount && this.value.bidAmount !== null && this.value.bidAmount !== ''));
    },
    // 是否勾选单独设置出价
    changeBidValueShow(v) {
      if (!v) {
        this.formData.bidAmount = null;
      }
      this.emitMsg();
    },
    // 对外提供的验证方法
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid, errors) => {
          if (valid) {
            resolve(true);
          } else {
            const errorMessages = Object.values(errors)
              .flat()
              .map((error) => error.message);
            reject(errorMessages);
          }
        });
      });
    },
  },
};
</script>
